
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { useTranslations } from "@/hooks/useTranslations";

interface ExperienceAndPricingProps {
  experienceYears: string;
  hourlyRate: string;
  showPrices: boolean;
  instagramUrl: string;
  facebookUrl: string;
  onExperienceYearsChange: (value: string) => void;
  onHourlyRateChange: (value: string) => void;
  onShowPricesChange: (value: boolean) => void;
  onInstagramUrlChange: (value: string) => void;
  onFacebookUrlChange: (value: string) => void;
}

export const ExperienceAndPricing = ({
  experienceYears,
  hourlyRate,
  showPrices,
  instagramUrl,
  facebookUrl,
  onExperienceYearsChange,
  onHourlyRateChange,
  onShowPricesChange,
  onInstagramUrlChange,
  onFacebookUrlChange
}: ExperienceAndPricingProps) => {
  const { t } = useTranslations("profile");
  
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label className="text-slate-800 dark:text-gray-200">{t("yearsExperience")}</Label>
          <Input
            type="number"
            value={experienceYears}
            onChange={e => onExperienceYearsChange(e.target.value)}
            placeholder="Ex: 5"
            className="bg-white dark:bg-gray-700 text-slate-900 dark:text-gray-100 border-slate-200 dark:border-gray-600"
          />
        </div>
        
        <div className="space-y-2">
          <Label className="text-slate-800 dark:text-gray-200">{t("hourlyRate")} (€)</Label>
          <Input
            type="number"
            value={hourlyRate}
            onChange={e => onHourlyRateChange(e.target.value)}
            placeholder="Ex: 30"
            className="bg-white dark:bg-gray-700 text-slate-900 dark:text-gray-100 border-slate-200 dark:border-gray-600"
          />
        </div>
      </div>
      
      <div className="flex items-center space-x-2">
        <Switch
          checked={showPrices}
          onCheckedChange={onShowPricesChange}
          className="dark:bg-gray-600 dark:data-[state=checked]:bg-gray-300"
        />
        <Label className="text-slate-800 dark:text-gray-200">{t("showPricesOnProfile")}</Label>
      </div>
      
      <div className="space-y-2">
        <Label className="text-slate-800 dark:text-gray-200">{t("instagramUrl")}</Label>
        <Input
          value={instagramUrl}
          onChange={e => onInstagramUrlChange(e.target.value)}
          placeholder="https://instagram.com/seu-perfil"
          className="bg-white dark:bg-gray-700 text-slate-900 dark:text-gray-100 border-slate-200 dark:border-gray-600"
        />
      </div>
      
      <div className="space-y-2">
        <Label className="text-slate-800 dark:text-gray-200">{t("facebookUrl")}</Label>
        <Input
          value={facebookUrl}
          onChange={e => onFacebookUrlChange(e.target.value)}
          placeholder="https://facebook.com/seu-perfil"
          className="bg-white dark:bg-gray-700 text-slate-900 dark:text-gray-100 border-slate-200 dark:border-gray-600"
        />
      </div>
    </div>
  );
};
